import { Component, Input } from "@angular/core";
import { getTranslation } from "../../utils/utils";

export type GridActionItem = {
	textKey: string;
	image?: string;
	disabled?: (data: any) => boolean;
	show?: (data: any) => boolean;
	onClick: (data: any) => void;
};

@Component({
	selector: "rs-grid-action",
	templateUrl: "./grid-action.component.html",
	styleUrls: ["./grid-action.component.scss"],
})
export class GridActionComponent {
	translation: Record<string, string>;

  constructor() {
    this.translation = getTranslation();
  }
}
